<div class="grid--center max--height bg--medium-navy">
  <mat-spinner class="primary-spinner"></mat-spinner>
</div>
